export default __webpack_public_path__ + "static/media/step-1.daf29f5e.mp4";